<script setup lang="ts">
usePageViewTracking()
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator />
    <NuxtPage />
  </NuxtLayout>
</template>

<style lang="scss">
@use '@/assets/style/global.scss';
</style>
